import React, { Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { withApollo } from '@apollo/client/react/hoc'
import { useQuery } from 'components/graphql'
import { useTranslation } from 'react-i18next'

import Additions from './fragments/Additions'
import { appConfig } from 'gql/query'
import { Form, Checkbox } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'

const Restaurant = ({ data, formData: { additions, ...restVals }, mutations: { updateItem }, client }) => {
	const [t] = useTranslation()

	const { data: configData } = useQuery(appConfig.printerLocations, {
		fetchPolicy: 'cache-and-network'
	})

	const getPrinterLocations = field => {
		const items = configData?.getAppConfig?.cashRegisterGlobal?.printerLocations || []
		return items.map(({ value, dbIndex }, i) => (
			<Checkbox field={`${field}[${dbIndex}]`} label={value} key={dbIndex} />
		))
	}

	// const isPrintOptions = [
	// 	{ value: 0, label: `<${t('product_section.strings.standard')}>` },
	// 	{ value: 1, label: t('product_section.strings.always_print_receipt') }
	// ]

	return(
		<Fragment>
			<ContentBlock>
				<Form initialValues={restVals} onSubmit={vals => updateItem(vals)} smartSubmit updateByInitial>
					<Fragment>
						<Row>
							<Col xs={6}>
								<p className='form-group-label'>{t('product_section.strings.kitchen')}</p>
								<Checkbox field='isPrintOnlyInCafe' label={t('product_section.strings.print_if_inhouse')} />
								<Checkbox field='isAdditionRequired' label={t('product_section.strings.print_if_kitchen_info')} />
								{/*<Checkbox field='properties.KitchenReportOnlyOverMenu' label={t('product_section.strings.print_if_selected')} />*/}
								{/*<Checkbox field='isKitchenSplit' label={t('product_section.strings.split_kitchen_info')} />*/}
								
								<Checkbox field='isKitchenInfo' label={t('product_section.strings.only_kitchen_receipt')} />
								{/*<Checkbox field='isScreenKeyboard' label={t('product_section.strings.display_virtual_keyboard')} />*/}
								<p className='form-group-label'>{t('product_section.strings.kitchen_printer_location')}</p>
								{getPrinterLocations('printerLocations')}
								{/*<Select field='printReceipt' label={t('product_section.strings.gastro_order')} options={isPrintOptions} />*/}
							</Col>
							<Col xs={6}>
								{/* <Text field='ordermanListName' label='Orderman Listbezeichnung' />
								<Checkbox field='isOrdermanKitchenAmount' label='Menge bei Kücheinformation gesamthaft behandeln' /> */}
								<p className='form-group-label'>{t('product_section.strings.service_call')}</p>
								<Checkbox field='isServiceCall' label={t('product_section.strings.service_call_active')} />
								{/* <Checkbox field='isServiceCallOrderman' label='Service Call für Orderman aktivieren' /> */}
								{/*<p className='form-group-label'>{t('product_section.strings.service_call_printers')}</p>*/}
								{/*{getPrinterLocations('serviceCallPrinters')}*/}
							</Col>
						</Row>
					</Fragment>
				</Form>
			</ContentBlock>
			<Additions productAdditions={additions} onChange={vals => updateItem(vals)} productId={data.id} />
		</Fragment>
	)
}

export default withApollo(Restaurant)
